export const PAYMENT_METHOD_NAME = 'dokan_mangopay';
